import { useState } from "react";
import style from "./style.module.scss";
import ModalConfirm from "../Modal/modal-confirm";
import Tooltip2 from "../Tooltip";

export default function InfoModal(props) {
  const { title, body, size = "md", ...rest } = props;

  const [openInfo, setopenInfo] = useState(false);
  const closeModal = () => {
    setopenInfo(false);
  };
  return (
    <>
      <Tooltip2 tip="Clique para mais informações" placement="top">
        <span
          className={style.info_icon}
          onClick={() => {
            setopenInfo(!openInfo);
          }}
          {...rest}
        >
          ?
        </span>
      </Tooltip2>
      <ModalConfirm
        title={title || "Informações"}
        size={size}
        text={body}
        confirmText=""
        show={openInfo}
        closeModal={closeModal}
        options={[
          {
            label: "Entendi",
            buttonColor: "primary",
            effect: closeModal,
          },
        ]}
      />
    </>
  );
}
